import React from 'react'

import Grid from '@/component/Primitive/Grid'
import Column from '../../Column'
import WidgetArea from '../../WidgetArea'
import { func, number, object } from 'prop-types'

const StandardRowLayout = ({
  row,
  __url,
  article,
  instance,
  section,
  pageData,
  latestMagazineIssue,
  rowIndex,
  eventUmbrella
}) => (
  <Grid gutter="default" flex grow>
    {row.cols.map((column, columnIndex) => (
      <Column column={column} key={columnIndex}>
        <WidgetArea
          widgets={column.widgetArea.widgets}
          __url={__url}
          article={article}
          section={section}
          instance={instance}
          pageData={pageData}
          latestMagazineIssue={latestMagazineIssue}
          rowIndex={rowIndex}
          eventUmbrella={eventUmbrella}
        />
      </Column>
    ))}
  </Grid>
)

StandardRowLayout.propTypes = {
  row: object,
  __url: func.isRequired,
  article: object,
  section: object,
  instance: object,
  pageData: object,
  latestMagazineIssue: object,
  rowIndex: number,
  eventUmbrella: object
}

export default StandardRowLayout
